const { appCommunicationFramework } = require("./appCommunicationFramework");
const { trackUserSession } = require("./trackUserSession");

exports.pageLoad = (pagename, pagetype, obj = {}) => {
  try {
    if (window) {
      trackUserSession();
      window.dataLayer = window.dataLayer || [];
      var pre_pagename = window.sessionStorage.getItem("pre_pagename") || "",
        pre_pagetype = window.sessionStorage.getItem("pre_pagetype") || "";
      if (document.referrer != window.sessionStorage.getItem("referrer")) {
        pre_pagename != pagename
          ? window.sessionStorage.setItem("pre_pagename", pagename)
          : "";
        pre_pagetype != pagetype
          ? window.sessionStorage.setItem("pre_pagetype", pagetype)
          : "";
        window.sessionStorage.setItem("referrer", document.referrer);
      }

      if(localStorage.getItem("webview")==="true"){
        appCommunicationFramework.google_analytics_4.pageload.event_function({
          pagename,
          pagetype,
          pre_pagename,
          pre_pagetype,
          extra_params: obj,
        });
      }else{
        window.dataLayer.push({
          event: "page_push",
          pagename,
          pagetype,
          pre_pagename,
          pre_pagetype,
          extra_params: obj,
        });
      }
    }
  } catch (err) {
    console.warn("Window object is not found: " + err);
  }
};
exports.pushMeta = (metaobj) => {
  try {
    if (window) {
      trackUserSession();
      window.localStorage.setItem("userid",metaobj.profileId?metaobj.profileId:"");
      if(localStorage.getItem("webview")==="true"){
        appCommunicationFramework.google_analytics_4.custom_events.event_function("meta_push",{},{
          "metaobj":metaobj
        });
      }else{
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(metaobj);
      }
    }
  } catch (err) {
    console.warn("Window object is not found: " + err);
  }
};
exports.eventPush = (eventObj) => {
  try {
    if (window) {
      trackUserSession();
      if(localStorage.getItem("webview")==="true"){
        appCommunicationFramework.google_analytics_4.custom_events.event_function(eventObj.event,eventObj);
      }else{
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(eventObj);
      }
    }
  } catch (err) {
    console.warn("Window object is not found: " + err);
  }
};
exports.loginEvent = () => {
  try {
    trackUserSession();
    if(window.localStorage.getItem("isSignUpDone")){
      window.localStorage.removeItem("isSignUpDone");
    }
    if (window && !window.sessionStorage.getItem("signup")) {
      if(localStorage.getItem("webview")==="true"){
        appCommunicationFramework.google_analytics_4.custom_events.event_function("signin","","");
      }else{
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: "signin" });
      }
    }
  } catch (err) {
    console.warn("Window object is not found: " + err);
  }
};
exports.signupEvent = () => {
  try {
    if (window) {
      trackUserSession();
      if(!window.localStorage.getItem("isSignUpDone")){
        window.localStorage.setItem("show_notification", "yes");
        window.sessionStorage.setItem("signup", true);
        window.localStorage.setItem("isSignUpDone", true);
        if(localStorage.getItem("webview")==="true"){
          appCommunicationFramework.google_analytics_4.custom_events.event_function("signup","","");
        }else{
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: "signup" });
        }
      }
    }
  } catch (err) {
    console.warn("Window object is not found: " + err);
  }
};
exports.logoutEvent = () => {
  try {
    if (window) {
      trackUserSession();
      if(localStorage.getItem("webview")==="true"){
        appCommunicationFramework.google_analytics_4.custom_events.event_function("logout","","");
      }else{
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: "logout" });
      }
      if(window.localStorage.getItem("isSignUpDone")){
        window.localStorage.removeItem("isSignUpDone");
      }
    }
  } catch (err) {
    console.warn("Window object is not found: " + err);
  }
};
exports.searchEvent = (searchTerm, searchBy, searchType) => {
  try {
    if (window) {
      let previousSearchTerm = sessionStorage.getItem("searchTerm");
      if(previousSearchTerm && sessionStorage.getItem("searchTerm")!="null"){
        sessionStorage.setItem("previousSearchTerm",previousSearchTerm);
      }else{
        sessionStorage.setItem("previousSearchTerm","not_available");
      }
      sessionStorage.setItem("searchTerm",searchTerm);
      search_refinements();
      trackUserSession();
      if(localStorage.getItem("webview")==="true"){
        appCommunicationFramework.google_analytics_4.custom_events.event_function("search_success",{searchTerm,
          searchBy,
          searchType,},"");
      }else{
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "search_success",
          searchTerm,
          searchBy,
          searchType
        });
      }
    }
  } catch (err) {
    console.warn("Window object is not found: " + err);
  }
};
exports.searchToggle = (searchType) => {
  try {
    if (window) {
      trackUserSession();
      if(localStorage.getItem("webview")==="true"){
        appCommunicationFramework.google_analytics_4.custom_events.event_function("search_toggle",{"searchType":searchType},"");
      }else{
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "search_toggle",
          searchType
        });
      }
    }
  } catch (err) {
    console.warn("Window object is not found: " + err);
  }
};
exports.filterApply = (filter_type, filter_name) => {
  try {
    if (window) {
      handleSearchRefinements();
      trackUserSession();
      if(localStorage.getItem("webview")==="true"){
        appCommunicationFramework.google_analytics_4.custom_events.event_function("filter_apply",{"filter_type":filter_type,"filter_name":filter_name},"");
      }else{
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "filter_apply",
          filter_type,
          filter_name
        });
      }
    }
  } catch (err) {
    console.warn("Window object is not found: " + err);
  }
};
exports.filterRemove = (filter_type, filter_name) => {
  try {
    if (window) {
      handleSearchRefinements();
      trackUserSession();
      if(localStorage.getItem("webview")==="true"){
        appCommunicationFramework.google_analytics_4.custom_events.event_function("filter_remove",{filter_type,filter_name},"");
      }else{
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "filter_remove",
          filter_type,
          filter_name
        });
      }
    }
  } catch (err) {
    console.warn("Window object is not found: " + err);
  }
};
exports.sortApply = (sortType, sortName) => {
  try {
    if (window) {
      handleSearchRefinements();
      trackUserSession();
      if(localStorage.getItem("webview")==="true"){
        appCommunicationFramework.google_analytics_4.custom_events.event_function("sort_apply",{sortType,sortName},"");
      }else{
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "sort_apply",
          sortType,
          sortName
        });
      }
    }
  } catch (err) {
    console.warn("Window object is not found: " + err);
  }
};
exports.couponApplySuccess = (couponname) => {
  try {
    if (window) {
      trackUserSession();
      if(localStorage.getItem("webview")==="true"){
        appCommunicationFramework.google_analytics_4.custom_events.event_function("coupon_apply_success",{couponname},"");
      }else{
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "coupon_apply_success",
          couponname
        });
      }
    }
  } catch (err) {
    console.warn("Window object is not found: " + err);
  }
};
exports.couponApplyError = (couponname, error) => {
  try {
    if (window) {
      trackUserSession();
      if(localStorage.getItem("webview")==="true"){
        appCommunicationFramework.google_analytics_4.custom_events.event_function("coupon_apply_error",{couponname,error},"");
      }else{
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "coupon_apply_error",
          couponname, error
        });
      }
    }
  } catch (err) {
    console.warn("Window object is not found: " + err);
  }
};
exports.couponRemove = (couponname) => {
  try {
    if (window) {
      trackUserSession();
      if(localStorage.getItem("webview")==="true"){
        appCommunicationFramework.google_analytics_4.custom_events.event_function("coupon_remove",{couponname},"");
      }else{
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "coupon_remove",
          couponname
        });
      }
    }
  } catch (err) {
    console.warn("Window object is not found: " + err);
  }
};
exports.currencySwitchEvent = (baseCurrency, switchedCurrency) => {
  try {
    if (window) {
      trackUserSession();
      if(localStorage.getItem("webview")==="true"){
        appCommunicationFramework.google_analytics_4.custom_events.event_function("currency_switch",{baseCurrency,switchedCurrency},"");
      }else{
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "currency_switch",
          baseCurrency,
          switchedCurrency,
        });
      }
    }
  } catch (err) {
    console.warn("Window object is not found: " + err);
  }
};
exports.socialMediaClicks = (social_media_name, source) => {
  try {
    if (window) {
      trackUserSession();
      if(localStorage.getItem("webview")==="true"){
        appCommunicationFramework.google_analytics_4.custom_events.event_function("social_click",{social_media_name,source},"");
      }else{
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "social_click",
          social_media_name,
          source,
        });
      }
    }
  } catch (err) {
    console.warn("Window object is not found: " + err);
  }
};
exports.formView = (formname, formsource) => {
  try {
    if (window) {
      trackUserSession();
      if(localStorage.getItem("webview")==="true"){
        appCommunicationFramework.google_analytics_4.custom_events.event_function("form_view",{formname,formsource},"");
      }else{
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: "form_view", formname, formsource });
      }
    }
  } catch (err) {
    console.warn("Window object is not found: " + err);
  }
};

exports.quoteSubmit = (formname, formsource) => {
  try {
    if (window) {
      trackUserSession();
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: "quote_submit" });
    }
  } catch (err) {
    console.warn("Window object is not found: " + err);
  }
};


exports.formFallout = (feildname, formname, formsource) => {
  try {
    if (window) {
      trackUserSession();
      if(localStorage.getItem("webview")==="true"){
        appCommunicationFramework.google_analytics_4.custom_events.event_function("form_fallout",{formname,feildname,formsource},"");
      }else{
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "form_fallout",
          formname,
          formsource,
          feildname,
        });
      }
    }
  } catch (err) {
    console.warn("Window object is not found: " + err);
  }
};
exports.formError = (feildname, err, formname, formsource) => {
  try {
    if (window) {
      trackUserSession();
      if(localStorage.getItem("webview")==="true"){
        appCommunicationFramework.google_analytics_4.custom_events.event_function("form_error",{formname,feildname,err,formsource},"");
      }else{
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "form_error",
          formname,
          formsource,
          err,
          feildname,
        });
      }
    }
  } catch (err) {
    console.warn("Window object is not found: " + err);
  }
};
exports.formSubmit = (formname, formsource) => {
  try {
    if (window) {
      trackUserSession();
      if(localStorage.getItem("webview")==="true"){
        appCommunicationFramework.google_analytics_4.custom_events.event_function("form_submit",{formname,formsource},"");
      }else{
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: "form_submit", formname, formsource });  
      }
    }
  } catch (err) {
    console.warn("Window object is not found: " + err);
  }
};
exports.homeSectionClicks = (sectionName, linkText, obj = {}) => {
  try {
    if (window) {
      trackUserSession();
      if(localStorage.getItem("webview")==="true"){
        appCommunicationFramework.google_analytics_4.custom_events.event_function("home_section_clicks",{sectionName,linkText,obj},"");
      }else{
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "home_section_clicks",
          sectionName,
          linkText,
          obj,
        }); 
        }
    }
  } catch (err) {
    console.warn("Window object is not found: " + err);
  }
};
exports.topNavigation = (linkText) => {
  try {
    if (window) {
      trackUserSession();
      if(localStorage.getItem("webview")==="true"){
        appCommunicationFramework.google_analytics_4.custom_events.event_function("top_navigation",{linkText},"");
      }else{
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "top_navigation",
          linkText,
        });
      }
    }
  } catch (err) {
    console.warn("Window object is not found: " + err);
  }
};
exports.menuNavigation = (sectionName, linkText) => {
  try {
    if (window) {
      trackUserSession();
      console.log("Menu navigation called","--",sectionName,"--",linkText);
      if(localStorage.getItem("webview")==="true"){
        appCommunicationFramework.google_analytics_4.custom_events.event_function("menu_navigation",{sectionName,linkText},"");
      }else{
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "menu_navigation",
          sectionName,
          linkText,
        });
      }
    }
  } catch (err) {
    console.warn("Window object is not found: " + err);
  }
};
exports.footerNavigation = (sectionName, linkText) => {
  try {
    if (window) {
      trackUserSession();
      if(localStorage.getItem("webview")==="true"){
        appCommunicationFramework.google_analytics_4.custom_events.event_function("footer_navigation",{sectionName,linkText},"");
      }else{
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "footer_navigation",
          sectionName,
          linkText,
        });
      }
    }
  } catch (err) {
    console.warn("Window object is not found: " + err);
  }
};
// exports.checkoutPLPImpressionEE = (products, currencyCode, list_name) => {
//   try {
//     if (window) {
//       dataLayer.push({ ecommerce: null });
//       dataLayer.push({
//         event: "ee_plp_impression",
//         ecommerce: {
//           currencyCode,
//           impressions: {
//             actionField: { list: list_name },
//             products: products,
//           },
//         },
//       });
//     } else {
//       console.warn("Window object is not found");
//     }
//   } catch (err) {
//     console.warn("DataLayer push error in checkoutPLPImpressionEE: " + err);
//   }
// };

/* track PLP product views */
exports.checkoutPLPProductImpressionEE = (products, currencyCode) => {
  try {
    if (window) {
      trackUserSession();
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: "ee_plp_product_impression",
        ecommerce: {
          currencyCode,
          impressions: 
            products,
        },
      });
      viewItemList(products, currencyCode,"plp list");
    } else {
      console.warn("Window object is not found");
    }
  } catch (err) {
    console.warn("DataLayer push error in checkoutPLPProductImpressionEE: " + err);
  }
};

exports.checkoutPLPClickEE = (products, currencyCode, list_name) => {
  try {
    if (window) {
      if(list_name=="product-listing"){
        product_list_click(products,list_name);
      }

      handleSearchRefinements();
      trackUserSession();
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: "ee_plp_click",
        ecommerce: {
          currencyCode,
          click: {
            actionField: { list: list_name },
            products: [products],
          },
        },
      });
      select_item(products,currencyCode,list_name);
    } else {
      console.warn("Window object is not found");
    }
  } catch (err) {
    console.warn("DataLayer push error in checkoutPLPClickEE: " + err);
  }
};

/* track SPLP product views */
exports.checkoutSPLPProductImpressionEE = (products, currencyCode) => {
  try {
    if (window) {
      trackUserSession();
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: "ee_splp_product_impression",
        ecommerce: {
          currencyCode,
          impressions: 
            products,
        },
      });
      viewItemList(products, currencyCode,"slp list");
    } else {
      console.warn("Window object is not found");
    }
  } catch (err) {
    console.warn("DataLayer push error in checkoutSPLPProductImpressionEE: " + err);
  }
};

/* track Search product views */
exports.checkoutSearchProductImpressionEE = (products, currencyCode) => {
  try {
    if (window) {
      trackUserSession();
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: "ee_search_product_impression",
        ecommerce: {
          currencyCode,
          impressions: 
            products,
        },
      });
      viewItemList(products, currencyCode,"search list");
    } else {
      console.warn("Window object is not found");
    }
  } catch (err) {
    console.warn("DataLayer push error in checkoutSearchProductImpressionEE: " + err);
  }
};

exports.checkoutPDPClickEE = (products, currencyCode, list_name) => {
  try {
    if (window) {
      trackUserSession();
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: "ee_pdp_click",
        ecommerce: {
          currencyCode,
          click: {
            actionField: { list: list_name },
            products: [products],
          },
        },
      });
    } else {
      console.warn("Window object is not found");
    }
  } catch (err) {
    console.warn("DataLayer push error in checkoutPDPClickEE: " + err);
  }
};

exports.checkoutPDPViewEE = (products, currencyCode, list_name) => {
  try {
    if (window) {
      trackUserSession();
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: "ee_pdp_view",
        ecommerce: {
          currencyCode,
          detail: {
            actionField: { list: 'product-listing' },
            products: products,
          },
        },
      });
      view_item(products,currencyCode,list_name);
    } else {
      console.warn("Window object is not found");
    }
  } catch (err) {
    console.warn("DataLayer push error in checkoutPDPViewEE: " + err);
  }
};

exports.checkoutPDPRfqClickEE = (products, currencyCode, list_name) => {
  try {
    if (window) {
      trackUserSession();
      if(localStorage.getItem("webview")==="true"){
        appCommunicationFramework.google_analytics_4.custom_events.event_function("get_quote",{currencyCode,
          detail: {
            actionField: { list: 'product-listing' },
            products: products,
          }},"");
      }else{
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
          event: "ee_pdp_rfq_click",
          ecommerce: {
            currencyCode,
            detail: {
              actionField: { list: 'product-listing' },
              products: products,
            },
          },
        });
      }
    } else {
      console.warn("Window object is not found");
    }
  } catch (err) {
    console.warn("DataLayer push error in checkoutPDPViewEE: " + err);
  }
};

exports.checkoutPDPWidgetsViewEE = (products, currencyCode, list_name) => {
  try {
    if (window) {
      trackUserSession();
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: "ee_pdp_widget_view",
        ecommerce: {
          currencyCode,
          detail: {
            actionField: { list: list_name },
            products: products,
          },
        },
      });
      viewItemList(products, currencyCode,"pdp widget list");
    } else {
      console.warn("Window object is not found");
    }
  } catch (err) {
    console.warn("DataLayer push error in checkoutPDPViewEE: " + err);
  }
};

exports.checkoutAddToCartEE = (products, currencyCode) => {
  try {
    if (window) {
      trackUserSession();
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: "ee_addToCart",
        ecommerce: {
          currencyCode,
          add: {
            products: products,
          },
        },
      });
      add_to_cart(products,currencyCode);
    } else {
      console.warn("Window object is not found");
    }
  } catch (err) {
    console.warn("DataLayer push error in checkoutAddToCartEE: " + err);
  }
};
exports.checkoutRemoveFromCartEE = (products, currencyCode) => {
  try {
    if (window) {
      trackUserSession();
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: "ee_removeFromCart",
        ecommerce: {
          currencyCode,
          remove: {
            products: products,
          },
        },
      });
      remove_from_cart(products,currencyCode);
    } else {
      console.warn("Window object is not found");
    }
  } catch (err) {
    console.warn("DataLayer push error in checkoutRemoveFromCartEE: " + err);
  }
};
exports.checkoutShippingEE = (products, currencyCode) => {
  try {
    if (window) {
      trackUserSession();
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: "ee_shipping",
        currencyCode,
        ecommerce: {
          checkout: {
            actionField: { step: 2, option: "shipping" },
            products: products,
          },
        },
      });
      add_shipping_info(products,currencyCode);
    } else {
      console.warn("Window object is not found");
    }
  } catch (err) {
    console.warn("DataLayer push error in checkoutShippingEE: " + err);
  }
};
exports.checkoutCartViewEE = (products, currencyCode) => {
  try {
    if (window) {
      trackUserSession();
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: "ee_cart_view",
        currencyCode,
        ecommerce: {
          checkout: {
            actionField: { step: 1, option: "cart" },
            products: products,
          },
        },
      });
      view_cart(products,currencyCode);
    } else {
      console.warn("Window object is not found");
    }
  } catch (err) {
    console.warn("DataLayer push error in checkoutCartViewEE: " + err);
  }
};
exports.checkoutPaymentEE = (products, currencyCode) => {
  try {
    if (window) {
      trackUserSession();
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: "ee_payment",
        currencyCode,
        ecommerce: {
          checkout: {
            actionField: { step: 3, option: "payment" },
            products: products,
          },
        },
      });
      add_payment_info(products,currencyCode);
    } else {
      console.warn("Window object is not found");
    }
  } catch (err) {
    console.warn("DataLayer push error in checkoutCartViewEE: " + err);
  }
};
exports.checkoutPurchaseEE = (
  products,
  currencyCode,
  orderid,
  revenue,
  tax,
  shipping,
  coupon,
  affiliation,
  orderType,
  shippingMode,
  prepaid,
  postpaid
) => {
  try {
    if (window) {
      trackUserSession();
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: "ee_purchase",
        currencyCode,
        orderType,
        shippingMode,
        prepaid,
        postpaid,
        ecommerce: {
          purchase: {
            actionField: {
              id: orderid,
              affiliation: affiliation,
              revenue: 0,
              tax: 0,
              shipping: 0,
              coupon: 0,
            },
            products: products,
          },
        },
      });
      purchase(products,currencyCode,0,orderid,0,0);
    } else {
      console.warn("Window object is not found");
    }
  } catch (err) {
    console.warn("DataLayer push error in checkoutCartViewEE: " + err);
  }
};


/*

GA 4 Ecomm Events

 */
/* Product Impressions GA4 */
let viewItemList = (products,currencyCode,list_name) =>{
  try {
    let arry = [];
    let product = {};
    for(let i = 0; i< products.length; i++){
      product.item_id = products[i].id || "";
      product.item_name = products[i].name || "";
      product.index = products[i].index || "";
      product.item_category = products[i].category || "";
      product.price = products[i].price || "";
      arry.push(product);
      product = {};
    }
    if(window){
      if(localStorage.getItem("webview")==="true"){
        appCommunicationFramework.google_analytics_4.ecommerce.view_item_list(currencyCode,list_name || "plp list",arry);
      }else{
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
          event: "view_item_list",
          ecommerce: {
            item_list_id: list_name || "plp list",
            item_list_name: list_name || "plp list",
            items: arry
          }
        });
      }
    } else {
      console.warn("Window object is not found");
    }
  } catch (error) {
    console.warn("DataLayer push error in viewitemlist: " + error);
  }
}


/* Product click GA4 */
let select_item = (products,currencyCode,list_name) =>{
  try {
    let arry = [];
    let product = {};
    for(let i = 0; i< products.length; i++){
      product.item_id = products[i].id || "";
      product.item_name = products[i].name || "";
      product.index = products[i].position || "";
      product.item_category = products[i].category || "";
      product.price = products[i].price || "";
      arry.push(product);
      product = {};
    }
    if(window){
      if(localStorage.getItem("webview")==="true"){
        appCommunicationFramework.google_analytics_4.ecommerce.select_item(currencyCode,list_name ||"plp list",products.id,products.name,products.position,products.category || "",products.price || "","");
      }else{
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
          event: "select_item",
          ecommerce: {
            item_list_id: list_name || "plp list",
            item_list_name: list_name || "plp list",
            items: arry
          }
        });
      }
    } else {
      console.warn("Window object is not found");
    }
  } catch (error) {
    console.warn("DataLayer push error in select item: " + error);
  }
}
/* Product page load GA4 */
let view_item = (products,currencyCode,list_name) =>{
  try {
    let arry = [];
    let product = {};
    var val = 0;
    for(let i = 0; i< products.length; i++){
      product.item_id = products[i].id || "";
      product.item_name = products[i].name || "";
      product.index = products[i].position || "";
      product.item_category = products[i].category || "";
      product.price = products[i].price || "";
      val = val + products[i].price || 0;
      //product.quantity = 1;
      product.item_brand = products[i].brand || "";
      arry.push(product);
      product = {};
    }
    if(window){
      if(localStorage.getItem("webview")==="true"){
        appCommunicationFramework.google_analytics_4.ecommerce.view_item(currencyCode,list_name || "",products[0].id,products[0].name,products[0].position || "",products[0].category || "",products[0].price || 0,"", products[0].brand || "");
      }else{
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
          event: "view_item",
          ecommerce: {
            currency:currencyCode,
            value: val,
            items: arry
          }
        });
      }
    } else {
      console.warn("Window object is not found");
    }
  } catch (error) {
    console.warn("DataLayer push error in view item: " + error);
  }
}
/* Product added to cart GA4 */
let add_to_cart = (products,currencyCode) =>{
  try {
    let arry = [];
    let product = {};
    var val = 0;
    for(let i = 0; i< products.length; i++){
      product.item_id = products[i].id || "";
      product.item_name = products[i].name || "";
      product.index = products[i].position || "";
      product.item_category = products[i].category || "";
      product.price = products[i].price || "";
      val = val + products[i].price || 0;
      product.quantity = products[i].qty || 1;
      product.item_brand = products[i].brand || "";
      arry.push(product);
      product = {};
    }
    if(window){
      if(localStorage.getItem("webview")==="true"){
        appCommunicationFramework.google_analytics_4.ecommerce.add_to_cart(currencyCode,"",products[0].id,products[0].name,products[0].category || "",products[0].price || "",products[0].quantity || 1);
      }else{
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
          event: "add_to_cart",
          ecommerce: {
            currency:currencyCode,
            value: val,
            items: arry
          }
        });
      }
    } else {
      console.warn("Window object is not found");
    }
  } catch (error) {
    console.warn("DataLayer push error in add to cart ga4: " + error);
  }
}

/* Product removed from cart GA4 */
let remove_from_cart = (products,currencyCode) =>{
  try {
    let arry = [];
    let product = {};
    var val = 0;
    for(let i = 0; i< products.length; i++){
      product.item_id = products[i].id || "";
      product.item_name = products[i].name || "";
      arry.push(product);
      product = {};
    }
    if(window){
      if(localStorage.getItem("webview")==="true"){
        appCommunicationFramework.google_analytics_4.ecommerce.remove_from_cart(currencyCode,"",products[0].id,products[0].name,products[0].category || "",products[0].price || "",products[0].quantity || 1);
      }else{
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
          event: "remove_from_cart",
          ecommerce: {
            currency:currencyCode || "",
            items: arry
          }
        });
      }
    } else {
      console.warn("Window object is not found");
    }
  } catch (error) {
    console.warn("DataLayer push error in remove from cart: " + error);
  }
}

/* checkout begin (future event) GA4 */
let begin_checkout = (products,currencyCode) =>{
  try {
    let arry = [];
    let product = {};
    var val = 0;
    for(let i = 0; i< products.length; i++){
      product.item_id = products[i].id || "";
      product.item_name = products[i].name || "";
      product.index = products[i].position || "";
      product.item_category = products[i].category || "";
      product.price = products[i].price || "";
      val = val + products[i].price || 0;
      //product.quantity = 1;
      product.item_brand = products[i].brand || "";
      arry.push(product);
      product = {};
    }
    if(window){
      if(localStorage.getItem("webview")==="true"){
        appCommunicationFramework.google_analytics_4.ecommerce.add_shipping_info(currencyCode,arry);
      }else{
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
          event: "begin_checkout",
          ecommerce: {
            currency:currencyCode,
            value: val,
            items: arry
          }
        });
      }
    } else {
      console.warn("Window object is not found");
    }
  } catch (error) {
    console.warn("DataLayer push error in checkout begin: " + error);
  }
}
/* Shipping step GA4 */
let add_shipping_info = (products,currencyCode) =>{
  try {
    let arry = [];
    let product = {};
    var val = 0;
    for(let i = 0; i< products.length; i++){
      product.item_id = products[i].id || "";
      product.item_name = products[i].name || "";
      product.index = products[i].position || "";
      product.item_category = products[i].category || "";
      product.price = products[i].price || "";
      val = val + products[i].price || 0;
      product.item_brand = products[i].brand || "";
      arry.push(product);
      product = {};
    }
    if(window){
      if(localStorage.getItem("webview")==="true"){
        appCommunicationFramework.google_analytics_4.ecommerce.add_shipping_info(currencyCode,arry);
      }else{
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
          event: "add_shipping_info",
          ecommerce: {
            currency:currencyCode,
            value: val,
            items: arry
          }
        });
      }
    } else {
      console.warn("Window object is not found");
    }
  } catch (error) {
    console.warn("DataLayer push error in adding shipping info: " + error);
  }
}
/* payment step GA4 */
let add_payment_info = (products,currencyCode) =>{
  try {
    let arry = [];
    let product = {};
    var val = 0;
    for(let i = 0; i< products.length; i++){
      product.item_id = products[i].id || "";
      product.item_name = products[i].name || "";
      product.index = products[i].position || "";
      product.item_category = products[i].category || "";
      product.price = products[i].price || "";
      val = val + products[i].price || 0;
      product.item_brand = products[i].brand || "";
      arry.push(product);
      product = {};
    }
    if(window){
      if(localStorage.getItem("webview")==="true"){
        appCommunicationFramework.google_analytics_4.ecommerce.add_payment_info(currencyCode,arry);
      }else{
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
          event: "add_payment_info",
          ecommerce: {
            currency:currencyCode,
            value: val,
            items: arry
          }
        });
      }
    } else {
      console.warn("Window object is not found");
    }
  } catch (error) {
    console.warn("DataLayer push error in add payment: " + error);
  }
}
/* Product Purchase GA4 */
let purchase = (products,currencyCode,couponCode,transaction_id,tax,shipping) =>{
  try {
    let arry = [];
    let product = {};
    var val = 0;
    for(let i = 0; i< products.length; i++){
      product.item_id = products[i].id || "";
      product.item_name = products[i].name || "";
      product.index = products[i].position || "";
      product.item_category = products[i].category || "";
      product.price = products[i].price || "";
      val = val + products[i].price || 0;
      product.item_brand = products[i].brand || "";
      arry.push(product);
      product = {};
    }
    if(window){
      if(localStorage.getItem("webview")==="true"){
        appCommunicationFramework.google_analytics_4.ecommerce.purchase(currencyCode,transaction_id || "",val,tax,shipping,couponCode,arry);
      }else{
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
          event: "purchase",
          ecommerce: {
            transaction_id,
            value: val,
            tax,
            shipping,
            currency: currencyCode,
            coupon: couponCode,
            items: arry
          }
        });
      }
    } else {
      console.warn("Window object is not found");
    }
  } catch (error) {
    console.warn("DataLayer push error in ga4 purchase: " + error);
  }
}
/* View cart step GA4 */
let view_cart = (products,currencyCode) =>{
  try {
    let arry = [];
    let product = {};
    var val = 0;
    for(let i = 0; i< products.length; i++){
      product.item_id = products[i].id || "";
      product.item_name = products[i].name || "";
      product.index = products[i].position || "";
      product.item_category = products[i].category || "";
      product.price = products[i].price || "";
      val = val + products[i].price || 0;
      product.item_brand = products[i].brand || "";
      arry.push(product);
      product = {};
    }
    if(window){
      if(localStorage.getItem("webview")==="true"){
        appCommunicationFramework.google_analytics_4.ecommerce.view_cart(currencyCode,arry);
      }else{
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
          event: "view_cart",
          ecommerce: {
            currency:currencyCode,
            value: val,
            items: arry
          }
        });
      }
    } else {
      console.warn("Window object is not found");
    }
  } catch (error) {
    console.warn("DataLayer push error in view cart: " + error);
  }
}

/* End of GA4 Events */



exports.gotocart = () => {
  try {
    if (window) {
      if(localStorage.getItem("webview")==="true"){
        appCommunicationFramework.google_analytics_4.custom_events.event_function("gotocart","","");
      }else{
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "gotocart"
        });
      }
    }
  } catch (err) {
    console.warn("DataLayer push error in gotocart: " + err);
  }
};


exports.qalaraRecomBlockClick = (product_cat)=>{
  try {
    if (window) {
      trackUserSession();
      if(localStorage.getItem("webview")==="true"){
        appCommunicationFramework.google_analytics_4.custom_events.event_function("qalara_recom_block_click",{product_cat},"");
      }else{
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "qalara_recom_block_click",
          product_cat
        });
      }
    }
  } catch (err) {
    console.warn("DataLayer push error in qalaraRecomBlockView: " + err);
  }
}

exports.apiError = (api_name, errormsg, req_type, api_type) => {
  try {
    if (window) {
      trackUserSession();
      if(localStorage.getItem("webview")==="true"){
        appCommunicationFramework.google_analytics_4.errors.event_function(errormsg,"","",window.location.href || "","", {api_name,
          errormsg,
          req_type,
          api_type})
      }else{
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "api_error",
          api_name,
          errormsg,
          req_type,
          api_type
        });
      }
    }
  } catch (err) {
    console.warn("Window object is not found: " + err);
  }
};

// on thankYou page/ success page
exports.facebookPurchase = (value, currency, products) => {
  try {
    if (window) {
      trackUserSession();
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "facebook_purchase",
        value,
        currency,
        products
      });
    }
  } catch (err) {
    console.warn("DataLayer push error in facebookPurchase: " + err);
  }
};


exports.add_collection = (id,productCategory,productName,collectionPrice,currentCurrency) => {
  try {
    if (window) {
      trackUserSession();
      if(localStorage.getItem("webview")==="true"){
        appCommunicationFramework.google_analytics_4.custom_events.event_function("add_collection",{id,productName},"");
      }else{
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "add_collection",
          id,
          productName,
          productCategory,
          collectionPrice,
          currentCurrency
        });
      }
    }
  } catch (err) {
    console.warn("DataLayer push error in add_collection: " + err);
  }
};

exports.get_collection_quote = () => {
  try {
    if (window) {
      trackUserSession();
      if(localStorage.getItem("webview")==="true"){
        appCommunicationFramework.google_analytics_4.custom_events.event_function("get_collection_quote","","");
      }else{
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "get_collection_quote"
        });
      }
    }
  } catch (err) {
    console.warn("DataLayer push error in add_collection: " + err);
  }
};

exports.collections_proceed_to_checkout = () => {
  try {
    if (window) {
      trackUserSession();
      if(localStorage.getItem("webview")==="true"){
        appCommunicationFramework.google_analytics_4.custom_events.event_function("collections_proceed_to_checkout","","");
      }else{
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
        event: "collections_proceed_to_checkout"
        });
      }
    }
  } catch (err) {
    console.warn("DataLayer push error in add_collection: " + err);
  }
};

exports.unique_page_views = (pagename) =>{
  try{
    if(window){
      let visited_pages = localStorage.getItem('visited_pages');

      if(!visited_pages){
        localStorage.setItem("visited_pages",JSON.stringify({
          pageVisited: [pagename]
        }));
        if(localStorage.getItem("webview")==="true"){
          appCommunicationFramework.google_analytics_4.custom_events.event_function("unique_page_view","","");
        }else{
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
          event: "unique_page_view"
          });
        }
      }else{
        let visitedPage = JSON.parse(visited_pages);
        const checkInclude = visitedPage.pageVisited.includes(pagename);
        if(!checkInclude){
          let visitedPageList = [...visitedPage?.pageVisited,pagename];
          localStorage.setItem("visited_pages",JSON.stringify({
            pageVisited: visitedPageList
          }));

          if(localStorage.getItem("webview")==="true"){
            appCommunicationFramework.google_analytics_4.custom_events.event_function("unique_page_view","","");
          }else{
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
            event: "unique_page_view"
          });
          }
        }
      }
      let unique_page_view_data = JSON.parse(localStorage.getItem('visited_pages'));
      console.log("unique_page_view_data:",unique_page_view_data);
    }
  }
  catch(err){
    console.warn("DataLayer push error in unique_page_views: " + err);
  }
}

exports.result_page_view = (searchTerm) =>{
  try{
    if(window){
      if(localStorage.getItem("webview")==="true"){
        appCommunicationFramework.google_analytics_4.custom_events.event_function("result_page_view",{search_term:searchTerm},"");
      }else{
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
        event: "result_page_view",
        currentSearchTerm: searchTerm
        });
      }
      }
  }
  catch(err){
    console.warn("DataLayer push error in result_page_view: " + err);
  }
}

exports.search_exit = (searchTerm) =>{
  try{
    if(window){
      if(localStorage.getItem("webview")==="true"){
        appCommunicationFramework.google_analytics_4.custom_events.event_function("search_exit",{search_term:searchTerm},"");
      }else{
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "search_exit",
          search_exit_term: searchTerm
        });
      }
      }
  }
  catch(err){
    console.warn("DataLayer push error in result_page_view: " + err);
  }
}

let search_refinements = () =>{
  try{
    if(window){
      if(sessionStorage.getItem("searchRefinements")){
        let previousSearchTerm = sessionStorage.getItem("previousSearchTerm");
        if(previousSearchTerm && sessionStorage.getItem("previousSearchTerm")!="not_available"){
          let currentSearchRefinementData = JSON.parse(sessionStorage.getItem("searchRefinements"));
          let isTermExist = currentSearchRefinementData?.find((item)=>item.searchTerm==previousSearchTerm);
          console.log("isTermExist:",isTermExist);
          if(!isTermExist){  
            if(localStorage.getItem("webview")==="true"){
              appCommunicationFramework.google_analytics_4.custom_events.event_function("search_refinements",{search_term:previousSearchTerm},"");
            }else{
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: "search_refinements",
                search_refinement_term: previousSearchTerm
              });
            }
            modifySearchRefinmentsData(previousSearchTerm);
          }
        } 
      }else{
        let previousSearchTerm = sessionStorage.getItem("previousSearchTerm");
        if(previousSearchTerm && sessionStorage.getItem("previousSearchTerm")!="not_available"){
          if(localStorage.getItem("webview")==="true"){
            appCommunicationFramework.google_analytics_4.custom_events.event_function("search_refinements",{search_term:previousSearchTerm},"");
          }else{
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: "search_refinements",
              search_refinement_term: previousSearchTerm
            });
          }
            modifySearchRefinmentsData(previousSearchTerm);
        }
      }
      } 
  }
  catch(err){
    console.warn("DataLayer push error in result_page_view: " + err);
  }
}

let handleSearchRefinements = () =>{
  let searchTerm =sessionStorage.getItem("searchTerm");
  if(searchTerm && sessionStorage.getItem("searchTerm")!="null"){
    modifySearchRefinmentsData(searchTerm);
  }
}

let modifySearchRefinmentsData = (searchTerm) =>{
  let searchRefinementsData = sessionStorage.getItem("searchRefinements");
  if(searchRefinementsData){
    let currentSearchRefinementData = JSON.parse(searchRefinementsData);
    let isTermExist = currentSearchRefinementData?.find((item)=>item.searchTerm==searchTerm);
    if(!isTermExist){
      sessionStorage.setItem("searchRefinements",JSON.stringify([
        ...currentSearchRefinementData,
        {
          isSearchRefinements: false,
          searchTerm: searchTerm
        }
      ]));  
    }
  }else if(!searchRefinementsData){
    sessionStorage.setItem("searchRefinements",JSON.stringify([
      {
        isSearchRefinements: false,
        searchTerm: searchTerm
      }
    ]));
  }
}

exports.product_list_view = (products,page_type) =>{
  try{
    if(window){
      if(localStorage.getItem("webview")==="true"){
            appCommunicationFramework.google_analytics_4.custom_events.event_function("product_list_view",{
              plp_product_name:products.name,
              plp_product_id:products.id,
              page_type: page_type,
              product_category: products.category,
              product_price: products.price
            },"");
          }else{
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              product_list_performance: null
            });
            window.dataLayer.push({
            event: "product_list_view",
            product_list_performance: {
              productName: products.name,
              productId:products.id,
              page_type: page_type,
              product_category: products.category,
              product_price: products.price,
              productPosition: products.position+1,
            }
          });
          }
        }
  }
  catch(err){
    console.warn("DataLayer push error in product_list_view: " + err);
  }
}

let product_list_click = (products,page_type) =>{
  try{
    if(window){
      if(localStorage.getItem("webview")==="true"){
            appCommunicationFramework.google_analytics_4.custom_events.event_function("product_list_click",{
              product_position:products.position,
              plp_product_name:products.name,
              plp_product_id:products.id,
              page_type: page_type,
              product_category: products.category
            },"");
          }else{
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              product_list_performance: null
            });
            window.dataLayer.push({
            event: "product_list_click",
            product_list_performance: {
              productName: products.name,
              page_type: page_type,
              productId:products.id,
              productPosition: products.position,
              product_category: products.category
            }
          });
          }
        }
  }
  catch(err){
    console.warn("DataLayer push error in product_list_click: " + err);
  }
}

exports.rfq_click = (rfq_source,buyer_id) =>{
  try{
    if(window){
      if(localStorage.getItem("webview")==="true"){
            appCommunicationFramework.google_analytics_4.custom_events.event_function("rfq_click",{
              rfq_source: rfq_source,
              buyer_id: buyer_id
            },"");
          }else{
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              rfq_click: null
            });
            window.dataLayer.push({
            event: "rfq_click",
            rfq_click: {
              rfq_source: rfq_source,
              buyer_id: buyer_id
            }
          });
          }
        }
  }
  catch(err){
    console.warn("DataLayer push error in rfq_click: " + err);
  }
}

exports.useDetectWebView = () => {
  let isAndroidWebView;
  let isIosWebView;
  // Detect android webview

  if (window.navigator.userAgent.includes("wv")) {
    isAndroidWebView = true;
  }
  // Detect ios webview
  let userAgent = window.navigator.userAgent.toLowerCase(),
    safari = /safari/.test(userAgent),
    ios = /iphone|ipod|ipad/.test(userAgent);

  if (ios) {
    if (!safari) {
      isIosWebView = true;

      console.log("ios webview");
    }
  }

  if (isAndroidWebView === true || isIosWebView === true) {
    console.log("Running on WebView");

    return true;
  } else {
    console.log("Running on Normal Browser");

    return false;
  }
};

exports.speak_to_sourcing_expert = () => {
  try {
    trackUserSession();
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: "speak_to_sourcing_expert" });
  } catch (err) {
    console.warn("Window object is not found: " + err);
  }
};
